<dt-modal-content (closeClick)="dialogRef.close()">
  <ng-template #title i18n>Nightly-Version</ng-template>
  <ng-template #content>
    <p i18n>Du verwendest derzeit die <span class="nightly-text">Nightly</span> Version des Entscheidungsnavis.</p>
    <p i18n
      >Mit der Nightly-Version kannst Du Dich über den <span class="bold">aktuellen Stand der Entwicklung</span> des Entscheidungsnavis
      informieren und die neuesten Funktionen als erste ausprobieren. Allerdings befindet sich die Version noch in aktiver Entwicklung und
      <span class="bold">kann Fehler enthalten</span>, die die Funktionalität beeinträchtigen. Insbesondere kann es zu
      <span class="bold">Datenverlust</span> kommen.</p
    >
    <mat-error class="dt-error" i18n>Wir empfehlen ausdrücklich die Nightly-Version nicht produktiv zu nutzen.</mat-error>
    <mat-checkbox [(ngModel)]="dns" i18n>Nicht erneut anzeigen</mat-checkbox>
  </ng-template>
  <ng-template #footer>
    <button mat-raised-button color="accent" (click)="openNormalVersion()"
      ><mat-icon>open_in_new</mat-icon><ng-container i18n>Zum normalen Entscheidungsnavi</ng-container></button
    >
    <button mat-raised-button color="accent-less" (click)="dialogRef.close()" i18n>Weiter in der Nightly</button>
  </ng-template>
</dt-modal-content>
